import {usePageMeta} from "./usePageMeta";

// The browser tab's title: "<title> – Tristar Advanced Software", or just the site name. Screen readers announce it
// on each page change. Set again on every navigation, since SiteLayout resets it (for pages still loading).
export function usePageTitle(title?: string): void {
    usePageMeta({ title: title ?? '' });
}
